import { genericPostingActionCreator, getCookieValue } from 'app/actions/genericActionCreator'
import { catchCommonErrors } from 'app/actions/commonActionUtils'
import { fetchAssignmentDetailByLin } from './fetchAssignmentDetailAction'

import { ActionTypes } from 'redux-plupload'

export const uploaderInit = (options) => dispatch =>
  dispatch({ type: ActionTypes.INIT, payload: options })

export const removeFile = (file, handle) => dispatch =>
  dispatch({ type: ActionTypes.REMOVE_FILE, payload: { file }, meta: { handle: handle } })

export const startUpload = (handle) => dispatch =>
  dispatch({ type: ActionTypes.START, meta: { handle: handle } })

export const setOption = (payload, handle) => dispatch =>
  dispatch({ type: ActionTypes.SET_OPTION, payload, meta: { handle: handle } })

export const destroy = (handle) => dispatch =>
  dispatch({ type: ActionTypes.DESTROY, meta: { handle: handle } })

export const invokeTidewater = (propertyAppraisalId, tidewaterNote, lin) => {
  return (dispatch) => {
    dispatch(genericPostingActionCreator('TIDEWATER', 'posting'))
    fetch(`/lgyhub/api/appraiser-workspace/property-appraisal/${propertyAppraisalId}/tidewater`, {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify({
        noteAccess: 'EXTERNAL',
        noteType: 'APPRAISER_INVOKED_TIDEWATER',
        note: tidewaterNote,
      }),
      headers: new Headers({
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN')
      })
    }).then((response) => {
      return catchCommonErrors(dispatch, response, 'invoking Tidewater')
    }).then((responseJson) => {
      if (responseJson.status >= 400) {
        throw new Error(responseJson.errors[0].message)
      } else {
        dispatch(genericPostingActionCreator('TIDEWATER', 'posted', responseJson))
        dispatch(fetchAssignmentDetailByLin(lin))
      }
    }).catch((error) => {
      dispatch(genericPostingActionCreator('TIDEWATER', 'error'))
      console.error('Tidewater posting error: ', error)
    })
  }
}

export const uploadSalesContract = (payload) => async dispatch => {
  try {
      const response = await fetch('/lgyhub/api/appraiser-workspace/sales-contract', {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify(payload),
        headers: new Headers({ 'Content-Type': 'application/json', 'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN') })
      })
      const responseJson = await catchCommonErrors(dispatch, response, `sales contract uploading`)
      if (responseJson.status >= 400) {
        throw new Error(responseJson.errors[0].message)
      } else {
        dispatch({type:'SALES_CONTRACT_UPLOADED', data: responseJson})
      }
    } catch (error) {
      console.error('Sales Contract error: ', error)
      dispatch({type:'SALES_CONTRACT_UPLOAD_ERROR', error})
    }
}
